import { Box, Checkbox, CircularProgress, FormControl, InputLabel, List, ListItem, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import APIManager from '../../lib/apiManager';
import { sistema } from "../../model/Sistema";
import moment from "moment";
import Ubicaciones from "./components/Ubicaciones";
import DescripcionCard from "./components/DescripcionCard";

const Asistencia = ({ setBotonera, espacio }) => {

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('company');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);

  const [active, setActive] = useState(sistema?.dataDeBusqueda?.active ?? true);
  const [textoDeBusqueda, setTextoDeBusqueda] = useState(sistema?.dataDeBusqueda?.textoDeBusqueda ?? '');
  const [fechaDesde, setFechaDesde] = useState(new Date().toISOString().substring(0, 10));
  const [fechaHasta, setFechaHasta] = useState(new Date().toISOString().substring(0, 10));

  const [espacioSeleccionado, setEspacioSeleccionado] = useState(espacio);

  const [cambioEnFiltros, setCambioEnFiltros] = useState(false);
  const [nuevo, setNuevo] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const espacioColumn = {
    id: 'espacioNombre',
    numeric: false,
    disablePadding: false,
    label: 'Espacio',
  };

  const basicColumns = [{
    id: 'fecha',
    numeric: false,
    disablePadding: false,
    label: 'Fecha',
  },
  {
    id: 'descripcionStr',
    numeric: false,
    disablePadding: true,
    label: 'Descripción',
  },
  {
    id: 'ubicaciones',
    numeric: false,
    disablePadding: true,
    label: 'Reservas',
  },
  ];
  const [columns, setColumns] = useState(basicColumns);

  const isSelected = (name) => selected.indexOf(name) !== -1;

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const openItem = (event, id) => {
    navigate('/reservas/' + id);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const actualizarItems = () => {
    const filtros = { fechaDesde: fechaDesde, fechaHasta: fechaHasta, espacioSeleccionado: espacioSeleccionado };
    sistema.actual.filtros = !!sistema?.actual?.filtros ? { ...sistema.actual.filtros, ...filtros } : filtros;
    sistema.saveActual();
    setLoading(true);
    setRows([]);
    sistema.dataDeBusqueda = { textoDeBusqueda, active };
    let postData = {
      orderBy: 'fecha desc, tipo',
      paraAcceso: true,
      nombre: textoDeBusqueda,
      espacioID: espacioSeleccionado?.id ?? null,
    }
    if (!!fechaDesde) {
      postData.fechaDesde = fechaDesde;
    }
    if (!!fechaHasta) {
      postData.fechaHasta = fechaHasta;
    }
    APIManager.getList('reservasDelDia', postData, (response) => {
      if (response.success) {
        if (response.data.listado.length > 0) {
          if (!espacioSeleccionado) {
            setColumns([espacioColumn, ...basicColumns])
          } else {
            setColumns(basicColumns);
          }
        }
        const listado = response.data.listado.map(item => {
          // item.fecha = moment(item.fecha).format('L');
          item.ubicaciones = Object.values(item.ubicaciones);
          item.ubicaciones.map(element => {
            element.usuario = item.usuario;
            if (!!item.empresa) {
              element.empresa = item.empresa; return element
            }
          });
          item.espacioNombre = item.espacio?.nombre;
          item.imagen = item.empresa?.imagen || item.usuario?.imagen;
          return item;
        });
        sistema.actual.listado = listado;
        setRows(listado);
        setCambioEnFiltros(false);
        setLoading(false);
      }
    })
  }

  const marcarAsistencia = (usuarioID) => {
    if (!!usuarioID) {
      APIManager.sendRequest('post', 'usuario', 'marcarAsistencia', { usuarioID }, response => {
        if (response.success) {
          actualizarItems();
        }
      });
    }
  }

  const toggleActive = (event) => {
    setActive(!active);
  }

  const handleChangeTextoDeBusqueda = (event) => {
    setTextoDeBusqueda(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleFechaDesde = (event) => {
    setFechaDesde(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleFechaHasta = (event) => {
    setFechaHasta(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleChangeEspacio = (event) => {
    setEspacioSeleccionado(event.target.value);
    setCambioEnFiltros(true);
  }

  const handleChangeActive = event => {
    setActive(event.target.checked);
    setCambioEnFiltros(true);
  }

  const handleTextoDeBusquedaKeyup = (event) => {
    if (event.code === 'Enter') {
      actualizarItems();
    }
  }

  const handleAsistenciaClick = (item, ubicacion) => {
    // Hicieron click para marcar asistencia en una ubicacion
    marcarAsistencia(ubicacion.usuarioAsignadoID);
  }

  useEffect(() => {
    sistema.actual.active = active;
    setBotonera([
      { type: 'input', id: 'input-texto', inputType: 'text', title: 'Descripción', label: 'Descripción', value: textoDeBusqueda, onChange: handleChangeTextoDeBusqueda, onKeyUp: handleTextoDeBusquedaKeyup },
      // { type: 'text', id: 'input-fechaDesde', inputType: 'date', variant: 'standard', title: 'Fecha desde', label: 'Fecha desde', InputLabelProps: { shrink: true }, value: fechaDesde, onChange: handleFechaDesde },
      // { type: 'text', id: 'input-fechaHasta', inputType: 'date', variant: 'standard', title: 'Fecha hasta', label: 'Fecha hasta', InputLabelProps: { shrink: true }, value: fechaHasta, onChange: handleFechaHasta },
      // {
      //   type: 'select', id: 'select-espacio', control:
      //     <FormControl sx={{minWidth: 150}}>
      //       <InputLabel id="espacio-label">Espacio</InputLabel>
      //       <Select
      //         labelId="espacio-label"
      //         value={espacioSeleccionado}
      //         label="Espacio"
      //         disabled={espacios.length < 2}
      //         onChange={handleChangeEspacio}
      //       >
      //         <MenuItem value=''>Todos</MenuItem>
      //         {espacios.map(item => <MenuItem value={item}>{item.nombre}</MenuItem>)}
      //       </Select>
      //     </FormControl>
      //   , title: 'Espacio', label: 'Espacio', value: espacioSeleccionado, onChange: handleChangeEspacio
      // },
      { title: 'Buscar', label: 'Buscar', variant: (cambioEnFiltros ? 'contained' : 'outlined'), onClick: () => { actualizarItems() } },
      // { title: 'Nueva', label: 'Nueva', variant: 'outlined', onClick: (event) => { openItem(event, 'nuevo'); setNuevo(!nuevo) } },
    ]);
  }, [active, textoDeBusqueda, fechaDesde, fechaHasta, espacioSeleccionado, cambioEnFiltros, nuevo]);

  // useEffect(() => {
  //   setEspacioSeleccionado(espacio);
  //   setCambioEnFiltros(true);
  // }, [espacio]);

  useEffect(() => {
    // actualizarItems();
  }, [])

  return (
    <Box>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <Typography padding={2} fontWeight="bold" fontSize="large">Lista de Reservas</Typography>
        <TableContainer sx={{maxHeight: 'calc(100vh - 64px - 64px - 85px - 32px - 60px)'}}>
          <Table
            sx={{ minWidth: 750 }}
            stickyHeader
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <TableHead>
              <TableRow>
                {/* <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={selected.length > 0 && selected.length < rows.length}
                    checked={rows.length > 0 && selected.length === rows.length}
                    onChange={handleSelectAllClick}
                    inputProps={{
                      'aria-label': 'select all desserts',
                    }}
                  />
                </TableCell> */}
                {columns.map((headCell) => (
                  <TableCell
                    key={headCell.id}
                    align={headCell.numeric ? 'right' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                  >
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={createSortHandler(headCell.id)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {!!rows && rows.length > 0 ?
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                  rows.slice().sort(getComparator(order, orderBy)) */}
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.cliente_id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      // onClick={(event) => openItem(event, row.id ?? row.cliente_id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          onClick={(event) => handleClick(event, row.cliente_id)}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                      {columns.map(column => {
                        const columnValue = () => {
                          switch (column.id) {
                            case 'activo':
                              return row.activo ? 'SI' : 'NO';
                            case 'descripcionStr':
                              return <DescripcionCard {...row} />
                            case 'ubicaciones':
                              return <Ubicaciones ubicaciones={row.ubicaciones} onAsistencia={(ubicacion) => handleAsistenciaClick(row, ubicacion)} />;
                            case 'fecha':
                              return moment(row.fecha).format('L');
                            default:
                              return row[column.id];
                          }
                        }
                        return <TableCell
                          // component="th"
                          id={labelId}
                          // scope={columnIndex === 0 ? "row" : ""}
                          padding={column.disablePadding ? 'none' : 'normal'}
                          align={column.numeric ? 'right' : 'left'}
                        >
                          {columnValue()}
                        </TableCell>
                      })}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          : (loading
            ? <TableBody><TableRow><TableCell colSpan={columns.length} padding="normal" align="center"><CircularProgress /></TableCell></TableRow></TableBody>
            : <TableBody><TableRow><TableCell colSpan={columns.length} align="center"><Typography>{'No hay datos para mostrar'}</Typography></TableCell></TableRow></TableBody>)
          }
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Paper>
    </Box>
  );
}

export default Asistencia;